

































































































































































































































import Expand from '@/components/Expand.vue';
import Detalle from '@/components/Detalle.vue';
import Contrato from '@/models/Contrato';
import Cosecha from '@/models/Cosecha';
import Grano from '@/models/Grano';
import Resumen from '@/models/Resumen';
import Entidad from '@/models/Entidad';
export default {
	name: 'Contratos',
	inject: ['responsive'],
	props: {
		directo: Boolean,
	},
	components: {
		Expand,
		Detalle,
	},
	data() {
		return {
			pickerBeginDateAfterH: {
				disabledDate: this.disabledDateH,
			},
			pickerBeginDateAfterD: {
				disabledDate: this.disabledDateD,
			},
			radio: 1,
			codcomexpand: '',
			codtalexpand: '',
			numeroexpand: '',
			scrollPosition: 0,
			recordSelected: {},
			showBtnMore: false,
			searchDrawer: false,
			detailsDrawer: false,
			imprimiendo: false,
			descargando: false,
			imprime: false,
			tableGranos: true,
			loading: true,
			loadingExpand: false,
			expandido: false,
			grano: 0,
			granoselected: 0,
			active_tab: '',
			start: 0,
			limit: 7,
			resumen: '',
			codcom: '',
			searchForm: {
				fechaDesde: '',
				fechaHasta: '',
				cosechaselect: [],
				rangofecha: '',
			},
			searchRules: {
				fechaHasta: [{ type: 'date', required: true, message: 'Seleccione una fecha hasta', trigger: 'change' }],
			},
		};
	},
	watch: {
		granoselected() {
			this.resetData();
			this.callResumen();
		},
	},
	computed: {
		resumenes(): Resumen[] {
			// return this.$store.state.contratos.resumenes;
			return Array.isArray(this.$store.state.contratos.resumenes) ? this.$store.state.contratos.resumenes : [];
		},
		tableData(): Contrato[] {
			// return this.$store.state.contratos.items;
			return Array.isArray(this.$store.state.contratos.items) ? this.$store.state.contratos.items : [];
		},
		totales(): Object {
			return this.$store.state.contratos.totales;
		},
		granos(): Grano[] {
			// return this.$store.state.contratos.granos;
			const g = this.$store.state.contratos && this.$store.state.contratos.granos;
			return Array.isArray(g) ? g : [];
		},
		cosechas(): Cosecha[] {
			// return this.$store.state.contratos.cosechas;
			const c = this.$store.state.contratos && this.$store.state.contratos.cosechas;
			return Array.isArray(c) ? c : [];
		},
		entidadSelected(): Entidad {
			// return this.$store.state.perfil.entidadSelected;
			return this.$store.state.perfil.entidadSelected || ({} as any);
		},
	},
	filters: {
		capitalize: function (value: string): String {
			if (!value) return '';
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
		},
		numeric: function (value: number): String {
			return new Intl.NumberFormat('de-DE').format(value);
		},
	},
	methods: {
		blurIfRadioActive(evt?: Event) {
			// Si el foco está en el radio nativo, lo sacamos
			const el = document.activeElement as HTMLElement | null;
			if (el && el.classList && el.classList.contains('el-radio__original')) {
				el.blur();
			}
		},
		disabledDateD(date: Date): Boolean {
			if (this.searchForm.fechaHasta) return date > this.searchForm.fechaHasta;
			else return false;
		},
		disabledDateH(date: Date): Boolean {
			if (this.searchForm.fechaDesde) return date < this.searchForm.fechaDesde;
			else return false;
		},
		tableRowClassName({ row, rowIndex }): String {
			let bg,
				clase: string = '';
			if (rowIndex === 0) {
				bg = 'bgGray';
				this.gray = true;
			}
			if (this.tableData[rowIndex - 1] && this.tableData[rowIndex - 1].fecha !== row.fecha) bg = this.gray ? 'bgGray' : '';

			if (this.tableData[rowIndex - 1] && this.tableData[rowIndex - 1].fecha === row.fecha) clase = this.gray ? 'bgGray' : '';
			else if (this.tableData[rowIndex + 1] && this.tableData[rowIndex + 1].fecha === row.fecha) clase = `sacarBorde ${bg}`;
			else clase = `bordeArriba ${bg}`;

			return clase;
		},
		updateScroll(): void {
			const conta = document.querySelector('.el-main');
			if (conta) this.scrollPosition = conta.scrollTop;
		},
		load(row): void {
			row.expandido = true;
			this.codcomexpand = row.codcom;
			this.codtalexpand = row.codtal;
			this.numeroexpand = row.numero;
		},
		getSummaries(param): object {
			const { columns, data } = param;
			const sums: string[] = [];
			columns.forEach((column, index) => {
				if (index === 3) {
					sums[index] = 'Totales';
					return;
				}
				const values = data.map(item => Number(item[column.property]));
				if (!values.every(value => isNaN(value))) sums[index] = this.totales[column.property];
				else sums[index] = '';
			});

			return sums;
		},
		range(array, min, max) {
			return array.slice(min, max);
		},
		// changeGrano(tab): void {
		// 	this.$router.push(`/contratos/${this.granos[parseInt(tab.index)].grano}`);
		// 	this.granoselected = this.granos[parseInt(tab.index)].grano;
		// },
		changeGrano(tab): void {
			const idx = parseInt(tab.index, 10);
			const item = this.granos[idx];
			if (!item) return;

			const grano = String(item.grano);
			const profile = String(this.$route.params.profile || this.$store.state.perfil.activeProfile || 1);

			// si ya estoy en ese grano, no navego
			if (String(this.$route.params.grano) === grano) return;

			this.$router
				.push({
					name: 'ContratosGrano',
					params: { profile, grano },
				})
				.catch(() => {});

			this.granoselected = grano;
		},
		// Muestro el drawer con los detalles del movimiento
		showDetails(record: Contrato): void {
			this.detailsDrawer = !this.detailsDrawer;
			this.recordSelected = record;
			this.tableGranos = this.recordSelected.renglonesOtros && this.recordSelected.renglonesOtros.length !== 0;
		},
		// Busqueda que se realiza en el drawer
		// doSearch(): void {
		// 	//TODO: refactor
		// 	const me = this;
		// 	const gra = this.granos.filter(function (gr: Grano) {
		// 		return gr.descripcion == me.active_tab;
		// 	});
		// 	const desde = !this.responsive.isMobile
		// 		? this.searchForm.rangofecha[0]
		// 			? this.convertDate(this.searchForm.rangofecha[0])
		// 			: ' '
		// 		: this.searchForm.fechaDesde
		// 		? this.convertDate(this.searchForm.fechaDesde)
		// 		: ' ';
		// 	this.searchForm.fechaDesde = desde;
		// 	const hasta = !this.responsive.isMobile
		// 		? this.searchForm.rangofecha[1]
		// 			? this.convertDate(this.searchForm.rangofecha[1])
		// 			: ' '
		// 		: this.searchForm.fechaHasta
		// 		? this.convertDate(this.searchForm.fechaHasta)
		// 		: ' ';
		// 	this.searchForm.fechaHasta = hasta;
		// 	this.searchDrawer = false;
		// 	this.$router.push(`/contratos/${gra[0].grano}`);
		// 	this.resetData();
		// 	this.callResumen();
		// },
		doSearch(): void {
			// 1) Buscar el grano activo
			const list = Array.isArray(this.granos) ? this.granos : [];
			const gra = list.find((gr: Grano) => gr.descripcion === this.active_tab);

			// Helper: cerrar drawer y luego avisar
			const closeThenWarn = (msg: string) => {
				this.searchDrawer = false;
				this.$nextTick(() => {
					if (this.$message && this.$message.warning) this.$message.warning(msg);
				});
			};

			if (!gra) {
				closeThenWarn('Seleccione un grano válido');
				return;
			}

			// 2) Cerrar el drawer ANTES de navegar/avisar
			this.searchDrawer = false;

			// 3) Armar ruta destino y evitar navegación duplicada
			const profile = String(this.$route.params.profile || this.$store.state.perfil.activeProfile || 1);
			const target = { name: 'ContratosGrano', params: { profile, grano: String(gra.grano) } };

			const sameRoute =
				this.$route &&
				this.$route.name === 'ContratosGrano' &&
				String(this.$route.params.profile) === String(profile) &&
				String(this.$route.params.grano) === String(gra.grano);

			if (sameRoute) {
				this.granoselected = gra.grano;
				if (typeof this.resetData === 'function') this.resetData();
				if (typeof this.callResumen === 'function') this.callResumen();
				return;
			}

			// 4) Navegar y refrescar datos
			const vm = this;
			this.$router
				.push(target)
				.catch(function (err) {
					if (!err || err.name !== 'NavigationDuplicated') throw err;
				})
				.then(function () {
					vm.granoselected = gra.grano;
					if (typeof vm.resetData === 'function') vm.resetData();
					if (typeof vm.callResumen === 'function') vm.callResumen();
				});
		},
		convertDate(inputFormat: string): string {
			function pad(s: number) {
				return s < 10 ? '0' + s : s;
			}
			const d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
		},
		loadMore(): void {
			if (!this.responsive.isMobile) return;
			this.updateScroll();
			this.start = this.start + this.limit;
			this.refresh = false;
			this.callResumen();
		},
		loadMoreClick(): void {
			this.updateScroll();
			this.start = this.start + this.limit;
			this.refresh = false;
			this.callResumen();
		},
		doImprimir(type: string): void {
			let params = {
				url: './api/public/proxy/cgi/etenet_contratos',
				type: type,
				data: this.loadConfig(),
			};
			window.open(
				`${params.url}?fechaDesde=${params.data.params.fechaDesde}&fechaHasta=${params.data.params.fechaHasta}&codcom=${
					params.data.params.comprobantes
				}&codres=${params.data.params.codres}&grano=${params.data.params.grano}&cosecha=${
					params.data.params.cosecha
				}&token=${localStorage.getItem('accessToken')}&files=true&type=${params.type}&cooperativa=${
					this.$store.state.config.cuit
				}&entity_id=${this.$store.state.perfil.codent}`
			);
		},
		//metodo no utilizado, boton oculto
		downloadFiles(): void {
			let config = this.loadConfig();
			config.params.zip = true;
			config.params.imprime = true;
			let params = {
				url: './api/public/proxy/cgi/etenet_contratos',
				data: config,
			};
			this.descargando = true;
			this.$store.dispatch('downloadFiles', params).then(response => {
				if (!response) {
					this.$notify.error({
						title: 'Error',
						message: 'Error al descargar los archivos',
						position: 'top-right',
					});
				}
				this.descargando = false;
			});
		},
		downloadFile(num: number): void {
			let params = {
				num: num,
				recordSelected: this.recordSelected,
			};
			this.imprimiendo = true;
			this.$store.dispatch('downloadFileContratos', params).then(response => {
				if (!response) {
					this.$notify.error({
						title: 'Error',
						message: 'Error al descargar el archivo',
						position: 'top-right',
					});
				} else {
					const x = window.open();
					if (!x) throw new Error();
					x.document.open();
					x.document.write(`<iframe width="100%" height="100%" src="data:application/pdf;base64,${response.archivos.archivo}"></iframe>`);
					x.document.close();
				}
				this.imprimiendo = false;
			});
		},
		resetData(): void {
			this.$store.dispatch('resetItems');
			this.start = 0;
			this.limit = 7;
		},
		callResumen(): void {
			this.loading = true;
			const params = { start: this.start, limit: this.limit, data: this.loadConfig() };

			this.$store.dispatch('callResumenContratos', params).then((response: Contrato[]) => {
				if (response) {
					this.showBtnMore = response.length >= 7;
					this.loading = false;
					this.refresh = false;

					const list = this.granos;
					const grWanted =
						this.$route && this.$route.params && this.$route.params.grano
							? String(this.$route.params.grano)
							: list.length
							? String(list[0].grano)
							: null;

					let selected: any = null;
					for (let i = 0; i < list.length; i++) {
						if (String(list[i].grano) === String(grWanted)) {
							selected = list[i];
							break;
						}
					}

					this.active_tab = selected ? selected.descripcion : '';
					if (selected && String(this.granoselected) !== String(selected.grano)) {
						this.granoselected = String(selected.grano);
					}

					const conta: any = document.querySelector('.el-main');
					if (conta) conta.scrollTop = this.scrollPosition;
				} else {
					this.loading = false;
				}
			});
		},
		// callResumen(): void {
		// 	this.loading = true;
		// 	let params = {
		// 		start: this.start,
		// 		limit: this.limit,
		// 		data: this.loadConfig(),
		// 	};
		// 	this.$store.dispatch('callResumenContratos', params).then((response: Contrato[]) => {
		// 		if (response) {
		// 			response.length < 7 ? (this.showBtnMore = false) : (this.showBtnMore = true);
		// 			this.loading = false;
		// 			this.refresh = false;
		// 			const gr = this.$route.params.grano ? this.$route.params.grano : this.granos[0].grano;
		// 			this.active_tab = this.granos.filter((grano: Grano) => {
		// 				return grano.grano === gr;
		// 			})[0].descripcion;
		// 			const conta = document.querySelector('.el-main');
		// 			if (conta) conta.scrollTop = this.scrollPosition;
		// 		} else this.loading = false;
		// 	});
		// },
		loadConfig(): object {
			const fmt = (d: Date | string | null | undefined): string => {
				if (!d) return ' ';
				const dd = new Date(d);
				const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
				return `${pad(dd.getDate())}/${pad(dd.getMonth() + 1)}/${dd.getFullYear()}`;
			};

			const rf = Array.isArray(this.searchForm.rangofecha) ? this.searchForm.rangofecha : [];
			const fechaDesdeDesktop = rf[0] ? fmt(rf[0]) : ' ';
			const fechaHastaDesktop = rf[1] ? fmt(rf[1]) : ' ';

			const fechaDesdeMobile = this.searchForm.fechaDesde ? fmt(this.searchForm.fechaDesde) : ' ';
			const fechaHastaMobile = this.searchForm.fechaHasta ? fmt(this.searchForm.fechaHasta) : ' ';

			const fechaDesde = this.responsive.isMobile ? fechaDesdeMobile : fechaDesdeDesktop;
			const fechaHasta = this.responsive.isMobile ? fechaHastaMobile : fechaHastaDesktop;

			const cosecha = Array.isArray(this.searchForm.cosechaselect) ? `[${this.searchForm.cosechaselect.join(',')}]` : '[]';

			return {
				params: {
					fechadesde: fechaDesde,
					fechahasta: fechaHasta,
					codres: this.resumen || '',
					grano: this.granoselected || '',
					cosecha,
				},
			};
		},
		// loadConfig(): object {
		// 	let config = {
		// 		params: {
		// 			fechadesde: this.searchForm.fechaDesde,
		// 			fechahasta: this.searchForm.fechaHasta,
		// 			codres: this.resumen,
		// 			grano: this.granoselected,
		// 			cosecha: `[${this.searchForm.cosechaselect}]`,
		// 		},
		// 	};
		// 	return config;
		// },
		numberFormatter(row: Contrato): string {
			return `${row.codcom2}  ${row.codtal2}  ${row.numero2}`;
		},
		changeResumen(resumen: Resumen): void {
			this.$nextTick(() => {
				const el = document.activeElement as HTMLElement | null;
				if (el && el.classList.contains('el-radio__original')) el.blur();
			});
			this.resumen = resumen;
			this.loading = true;
			this.resetData();
			this.callResumen();
		},
	},
	mounted() {
		//TODO: para agegar la cosecha al router
		//this.searchForm.cosechaselect = this.$route.params.cosecha ? this.$route.params.cosecha : '';
		this.granoselected = this.$route.params.grano ? this.$route.params.grano : 1;
		//this.$router.push(`/contratos/${this.granoselected}/${this.searchForm.cosechaselect}`);
		// this.$router.push(`/contratos/${this.granoselected}`);
		if (!this.responsive.mobile) window.addEventListener('scroll', this.updateScroll);
	},
	destroyed() {
		if (!this.responsive.mobile) window.removeEventListener('scroll', this.updateScroll);
	},
};
